import { Icon } from '@buggy/shared'
import { FunctionComponent, memo } from 'react'
import { RankingPlatformType } from '@/types/schema/k6/analyze-api'
import { platformShortcodeSchema } from '@/types/schema/platform/platform-shortcode-schema'

interface PlatformIconProps {
  platform?: RankingPlatformType
}

const PlatformIcon: FunctionComponent<PlatformIconProps> = ({ platform }) => {
  switch (platform) {
    case undefined:
      return null
    case platformShortcodeSchema.enum.ig:
      return <Icon name='brand-instagram-filled' />
    case platformShortcodeSchema.enum.fb:
      return <Icon name='brand-facebook-filled' />
    case platformShortcodeSchema.enum.yt:
      return <Icon name='brand-youtube-filled' />
    default:
      return null
  }
}

export default memo(PlatformIcon)
